var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-24 flex items-center"},[_c('p',{staticClass:"text-center w-full text-80"},[_vm._v(_vm._s(_vm.$t('No data matched your search criteria.')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }